import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type FooterElement =
  | {
      type: 'component';
      content: 'lib-theme-selector';
      props?: {
        variant?: 'select' | 'toggle';
        class?: string;
        [key: string]: unknown;
      };
    }
  | {
      type: 'component';
      content: 'lib-i18n';
      props?: {
        variant?: 'select' | 'toggle' | 'switch';
        class?: string;
        [key: string]: unknown;
      };
    }
  | {
      type: 'html';
      content: string;
      props?: Record<string, unknown>;
    };

export interface FooterConfig {
  showDefault: boolean;
  customElements?: FooterElement[];
  appName?: string;
  environment?: string;

  /** Oculta el enlace de "¿Olvidaste tu contraseña?" */
  hideForgotPasswordLink?: boolean;

  /** Oculta el botón de "Ingresar con Azure" */
  hideAzureLoginButton?: boolean;

  /** Oculta el enlace de "¿No tienes cuenta?" */
  hideRegisterLink?: boolean;

  /** Oculta el componente de i18n */
  hideI18n?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class LayoutConfigService {
  private _footerConfig = new BehaviorSubject<FooterConfig>({
    showDefault: true,
  });

  footerConfig$ = this._footerConfig.asObservable();

  setFooterConfig(config: FooterConfig) {
    this._footerConfig.next(config);
  }

  // Métodos de conveniencia
  showDefaultFooter() {
    this.setFooterConfig({ showDefault: true });
  }

  hideDefaultFooter() {
    this.setFooterConfig({ showDefault: false });
  }

  setCustomFooter(elements: FooterElement[]) {
    this.setFooterConfig({
      showDefault: false,
      customElements: elements,
    });
  }
}
